import { createContext, Fragment, useEffect, useState } from "react";
import { Cursor, PreLoader } from "../components/index";
import {
  baseUrl,
  footerEndPoint,
  getNewsCategory,
  getProject,
} from "../utils/apiData";
import axios from "axios";
import { LoadScript } from "@react-google-maps/api";
import { formRange } from "../utils/enum";
import { IoLogoWhatsapp } from "react-icons/io5";

export const MainContext = createContext();

const WebContextWrap = ({ children }) => {
  const [menuStatus, setMenuStatus] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [previewNum, setPreviewNum] = useState(0);
  const [projects, setProjects] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [pre, setPre] = useState(false);
  const [currentLocation, setCurrentLocation] = useState({});
  const [eventCategory, setEventCategory] = useState([]);
  const [footerData, setFooterData] = useState({});
  const [projectDd, setProjectDd] = useState(false);
  const [formType, setFormType] = useState(formRange.DOMESTIC);
  useEffect(() => {
    setPre(true);

    const timeOutId = setTimeout(() => {
      setPre(false);
    }, 3000);

    return () => clearTimeout(timeOutId);
  }, []);

  const getProjectsApi = async () => {
    try {
      const res = await axios.get(`${baseUrl}/${getProject}`);
      if (res?.data?.success) {
        setProjects(res?.data?.data);

        setLocationData(
          res?.data?.data
            ?.filter((ele) => ele?.project_category === "Builder")
            ?.map((ele) => {
              return {
                _id: ele?._id,
                img: `${baseUrl}/${ele?.image}`,
                location: ele?.name,
                desc: ele?.description,
                lat: ele?.lat,
                lng: ele?.long,
                slug: ele?.slug,
                type: ele?.project_category,
              };
            })
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Project Category APi
  const getNewsCategotyApi = async () => {
    try {
      const res = await axios.get(`${baseUrl}/${getNewsCategory}`);
      if (res?.data?.success) {
        setEventCategory(res?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Footer APi
  const getFooterApi = async () => {
    try {
      const res = await axios.get(`${baseUrl}/${footerEndPoint}`);
      if (res?.data?.success) {
        setFooterData(res?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getNewsCategotyApi();
    getProjectsApi();
    getFooterApi();
  }, []);

  const passedData = {
    menuStatus,
    setMenuStatus,
    showContact,
    setShowContact,
    previewNum,
    setPreviewNum,
    locationData,
    currentLocation,
    setCurrentLocation,
    projects,
    formType,
    setFormType,
    eventCategory,
    setEventCategory,
    footerData,
    projectDd,
    setProjectDd,
  };

  return (
    <MainContext.Provider value={passedData}>
      <LoadScript googleMapsApiKey="AIzaSyA6LkAp3FZarhyEMai2WoSyXgITjsyygTY">
        {pre ? (
          <PreLoader />
        ) : (
          <Fragment>
            <Cursor />
            {children}
            <a href={`https://wa.me/${footerData?.wp_chat_number}`} target="_blank" className="chat_boat"><IoLogoWhatsapp /></a>
          </Fragment>
        )}
      </LoadScript>
    </MainContext.Provider>
  );
};

export default WebContextWrap;
